import type { SeoFormValues } from '@store/reducers/seo/types'
import type React from 'react'

import css from './styles.module.css'

interface Props extends SeoFormValues {
  imagePath: string
}

export const CodeRow: React.FC<Props> = ({
  imagePath,
  title,
  description,
  url,
}) => {
  const primaryMetaTags = {
    comment: '<!-- Primary Meta Tags -->',
    title: `<title>${title}</title>`,
    metaTitle: `<meta name='title' content='${title}' />`,
    metaDescription: `<meta name='description' content='${description}' />`,
  }

  const openGraph = {
    comment: '<!-- Open Graph / Facebook -->',
    metaType: `<meta property='og:type' content='website'>`,
    metaUrl: `<meta property='og:url' content='${url}'>`,
    metaTitle: `<meta property='og:title' content='${title}'>`,
    metaDescription: `<meta property='og:description' content='${description}' />`,
    metaImage: `<meta property='og:image' content='${imagePath}' />`,
  }

  const twitterMetaTags = {
    comment: '<!-- Twitter -->',
    metaCard: `<meta property='twitter:card' content='summary_large_image'>`,
    metaUrl: `<meta property='twitter:url' content='${url}'>`,
    metaTitle: `<meta property='twitter:title' content='${title}'>`,
    metaDescription: `<meta property='twitter:description' content='${description}' />`,
    metaImage: `<meta property='twitter:image' content='${imagePath}' />`,
  }

  return (
    <div className={css.code_row}>
      <div>{primaryMetaTags.comment}</div>
      <div>{primaryMetaTags.title}</div>
      <div>{primaryMetaTags.metaTitle}</div>
      <div>{primaryMetaTags.metaDescription}</div>

      <br />

      <div>{openGraph.comment}</div>
      <div>{openGraph.metaType}</div>
      <div>{openGraph.metaUrl}</div>
      <div>{openGraph.metaTitle}</div>
      <div>{openGraph.metaDescription}</div>
      <div>{openGraph.metaImage}</div>

      <br />

      <div>{twitterMetaTags.comment}</div>
      <div>{twitterMetaTags.metaCard}</div>
      <div>{twitterMetaTags.metaUrl}</div>
      <div>{twitterMetaTags.metaTitle}</div>
      <div>{twitterMetaTags.metaDescription}</div>
      <div>{twitterMetaTags.metaImage}</div>
    </div>
  )
}
